module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CartItemAmount":{"modal":{"title":"Odebrat zboží z košíku?","remove":"Odebrat zboží","cancel":"Neodebrat"}}},"en":{"CartItemAmount":{"modal":{"title":"Remove items from your cart?","remove":"Remove items","cancel":"Do not remove"}}}}')
  delete Component.options._Ctor
}
